<template>
	<div class="trade-detail">
		<!-- header -->
		<!-- <div class="trade-detail.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="trade-detail.block">
			<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="trade-detail.bread">
			<Bread :currentPage="{name:'商标商城',path:'/Trademark',childName:'商标详情',childPath:$route.path}" />
		</div>
		<div class="trade-detail.container">
            <common-detail :details="tradeDetailFnl[0]"></common-detail>
			<trade-intro></trade-intro>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'
	import CommonDetail from '../components/common-detail.vue'
	import TradeIntro from '../components/trade-intro.vue'

	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,
			CommonDetail,
			TradeIntro

		},
		data(){
			return{
				isTrademark:false,
				tradeDetail:[]
			}
		},
		computed:{
			tradeDetailFnl(){
				return this.tradeDetail.map(({ name, image, description, id,date_time,platform,attribute_name,first_category_name,second_category_name,apply,price}) => {
						return {
							type:'商标',
							name: name,
							icon: this.imgUrl + image,
							desc: description,
							id: id ,
							date:date_time,
							platforms:platform.split(','),
							tradeType:first_category_name ? (attribute_name + '/' + first_category_name + '/' +second_category_name) : attribute_name ,
							Application:apply,
							price:price,
							tel:18152117607,
							
						}
					})
			}
		},
		methods:{
			toggleTrademarks(val){
				this.isTrademark = val
			},
			initTraddeDetail(){
				this.http.get(`IPR_Trademark/${this.$route.params.id}`).then(res => {
					this.tradeDetail = []
					this.tradeDetail.push(res.data)	
				})
			}
		},
		created(){
			window.scrollTo(0,0);
			this.initTraddeDetail()
		},
	}
</script>

<style lang="scss">
	@include component(trade-detail) {
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}

		@include part(bread) {
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}

		@include part(container) {
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;

		}

	}
</style>
